// The editor creator to use.
import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'

import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials'
import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter'
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat'
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold'
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic'
import Font from '@ckeditor/ckeditor5-font/src/font'
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote'
import Heading from '@ckeditor/ckeditor5-heading/src/heading'
import Image from '@ckeditor/ckeditor5-image/src/image'
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption'
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle'
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar'
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload'
import Link from '@ckeditor/ckeditor5-link/src/link'
import List from '@ckeditor/ckeditor5-list/src/list'
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline'

import store from '../plugins/store'

export default class ClassicEditor extends ClassicEditorBase {}

// Plugins to include in the build.
ClassicEditor.builtinPlugins = [
    Essentials,
    UploadAdapter,
    Autoformat,
    Bold,
    Italic,
    BlockQuote,
    Heading,
    Image,
    ImageCaption,
    ImageStyle,
    ImageToolbar,
    ImageUpload,
    Link,
    List,
    Paragraph,
    Alignment,
    Font,
    SimpleUploadAdapter,
    Underline,
]

const defaultHexColorPalette = [
    {
        color: '#000000',
        label: 'Black'
    },
    {
        color: '#4d4d4d',
        label: 'Dim grey'
    },
    {
        color: '#999999',
        label: 'Grey'
    },
    {
        color: '#e6e6e6',
        label: 'Light grey'
    },
    {
        color: '#ffffff',
        label: 'White',
        hasBorder: true
    },
    {
        color: '#e64d4d',
        label: 'Red'
    },
    {
        color: '#e6994d',
        label: 'Orange'
    },
    {
        color: '#e6e64d',
        label: 'Yellow'
    },
    {
        color: '#99e64d',
        label: 'Light green'
    },
    {
        color: '#4de64d',
        label: 'Green'
    },
    {
        color: '#4de699',
        label: 'Aquamarine'
    },
    {
        color: '#4de6e6',
        label: 'Turquoise'
    },
    {
        color: '#4d99e6',
        label: 'Light blue'
    },
    {
        color: '#4d4de6',
        label: 'Blue'
    },
    {
        color: '#994de6',
        label: 'Purple'
    }
]

// Editor configuration.
ClassicEditor.defaultConfig = {
    toolbar: {
        shouldNotGroupWhenFull: true,
        items: [
            'heading',
            '|',
            'alignment',
            'bold',
            'italic',
            'underline',
            'fontSize',
            'fontFamily',
            'fontColor',
            'fontBackgroundColor',
            'link',
            'bulletedList',
            'numberedList',
            'imageUpload',
            'blockQuote',
            'undo',
            'redo'
        ]
    },
    fontColor: {
        colors: defaultHexColorPalette,
        columns: 5
    },
    fontBackgroundColor: {
        colors: defaultHexColorPalette,
        columns: 5
    },
    image: {
        toolbar: ['toggleImageCaption'],
        styles: ['alignLeft']
    },
    // This value must be kept in sync with the language defined in webpack.config.js.
    language: 'fr',
    simpleUpload: {
        // The URL that the images are uploaded to.
        uploadUrl: process.env.VUE_APP_API_URL + '/api/auth/user/upload-signature',
        headers: {
            Authorization: 'Bearer ' + store.getters['account/token']
        }
    }
}
